<template>
  <div>
    <utility-detail-link ref="utilityDetailLink" :detailLayout="detailLayout" :utilityData="utilityData"
                         :utilKey="utilKey" :userKey="userKey" :utilTopCategory="utilityTopCategoryList" :utilBottomCategory="utilityBottomCategoryList"
                         :defaultApiParamsSet="defaultApiParamsSet"></utility-detail-link>
  </div>

</template>

<script>
import util from "../../mixins/util";
import alertMixins from "../../mixins/alertMixins";
import UtilityDetailLink from "@/components/utility/UtilityDetailLink.vue";
import utilityUtil from "@/components/utility/utilityUtil";
import EventBus from "@/utils/event-bus";

export default {
  name: "UtilityPubDetailComponent",
  mixins: [utilityUtil, alertMixins],
  components: {UtilityDetailLink},
  inject: [],
  provide() {
    return {}
  },
  props: {
    utilityType: {
      default: () => {
      }
    },
    utilKey: {default: 0},
    userKey: {default: 0},
    defaultApiParamsSet: {}
  },
  data() {
    return {
      detailLayout: '',
      getFunc: '',
      utilityData: {},
      deleteFunc: '',
      deleteApiParamsSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      keyName: '',
      DeleteClass: null,

      utilityTopCategoryList: [],
      utilityBottomCategoryList: [],
    }
  },
  beforeRouterEnter() {
  },
  created() {
    this.initData();
  },
  mounted() {
    EventBus.$on('utilDelete', this.runDeleteConfirm)
    this.getUtilTopCategory();
    this.getUtilBottomCategory();
  },
  beforeUnmount() {
    EventBus.$off('utilDelete')
  },
  unmounted() {
  },
  computed: {},
  methods: {
    initData() {
      let config = this.returnUtilityConfig(this.utilityType);
      this.detailLayout = config.detailLayout;
      this.getFunc = config.getFunc;
      this.detailApiParamSet = config.detailApiParamSet;
      this.keyName = config.keyName;
      this.deleteFunc = config.deleteFunc
      this.deleteApiParamsSet = config.deleteApiParamsSet
      this.deleteSuccessType = config.deleteSuccessType
      this.deleteFailTypes = config.deleteFailTypes
      this.deleteKeyName = config.deleteKeyName
      this.getUtilityDetail()

    },
    getUtilityDetail() {
      let params = Object.assign({}, this.detailApiParamSet, this.defaultApiParamsSet);
      params[this.keyName] = this.utilKey

      try {
        this.$api.$utility[this.getFunc](params).then(res => res.Data.Result).then(res => {
          if (!util.isEmpty(res.List)) {
            this.utilityData = res.List[0];
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    runDeleteConfirm(key) {
      this.createConfirm({
        content: '정말 삭제하시겠습니까?',
        confirm: () => {
          this.runDelete(key);
        }
      })
    },
    runDelete(key) {
      let params = {
        u_idx: key,
      }
      try {
        this.$api.$utility[this.deleteFunc](params).then(res => res.Data.Result).then(res => {
          let result = res.Info.status
          console.log(result);
          if (!result) {
            this.errorAlert('삭제에 실패했습니다.');
            return false;
          } else {
            this.deleteAfterFunc();

          }
        })
      } catch (e) {
        this.changeLoading(false);
        this.isRunning = false;
        console.log(e);
      }
    },
    deleteAfterFunc() {
      this.createAlert({
        content: '삭제되었습니다.',
        hide: () => {
          this.$router.push(`/nticket/utility`);
          this.getList()
        }
      })
    },
    getUtilTopCategory() {
      let params = {
        parent : [0],
      };

      try {
        this.$api.$utility.getUtilityCategory(params).then(res => res.Data.Result).then(res => {
          if (!util.isEmpty(res.List)) {
            this.utilityTopCategoryList = res.List;
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    getUtilBottomCategory() {
      let params = {
        child : 1,
      };

      try {
        this.$api.$utility.getUtilityCategory(params).then(res => res.Data.Result).then(res => {
          if (!util.isEmpty(res.List)) {
            this.utilityBottomCategoryList = res.List;
          }
        })
      } catch (e) {
        console.log(e)
      }
    },

  },
  watch: {},
};
</script>

<style scoped>

</style>
